<div class="container-fluid m-0 p-0">
    <div class="row">
        
        <div class="col-12">
            <div class="bg-white border pt-3 my-4">
                <h5 class="font-16 font-black px-3" style="display:inline;clear:none;">{{ "AVAILABLE_DATES" |
                    translate
                    | titlecase }}</h5>
                <app-loader [show]="showLoader"></app-loader>
                <br>
                <div id="accordion" *ngIf="showLoader==false">
                    <div class="card">
                        <div id="collapseOne">
                            <div class=" card-body">
                                <form [formGroup]="searchForm" (change)="searchFormChange()"
                                    (submit)="searchFormSubmit()">
                                    <div class="row">
                                        <div class="col-md-3 form-group px-md-5 mb-1">
                                            <label class="font-bold">{{ "ACADMIC_YEAR" | translate | titlecase
                                                }}</label>
                                            <select class="form-control custom-select" formControlName="year"
                                                (change)="getYearSemesters()">
                                                <option value="" [selected]="true">{{ "SELECT" | translate | titlecase
                                                    }}
                                                </option>
                                                <option *ngFor="let field of years" [ngValue]="field.id">
                                                    {{
                                                    (globals.lang == 'ar')? field?.yearDescAr : field?.yearDescEn
                                                    }}
                                                </option>
                                            </select>
                                            <div class="alert alert-danger py-1 mt-1"
                                                *ngIf="searchForm.controls.year.touched && searchForm.controls.year.invalid && searchForm.dirty">
                                                {{ "THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                            </div>
                                        </div>
                                        <div class="col-md-3 form-group px-md-5 mb-1">
                                            <label class="font-bold">{{ "SEMESTER" | translate | titlecase }}</label>
                                            <select class="form-control custom-select" formControlName="semester"
                                                (change)="getBatches()">
                                                <option value="" [selected]="true">{{ "SELECT" | translate | titlecase
                                                    }}
                                                </option>
                                                <option *ngFor="let field of semesters" [ngValue]="field.id">
                                                    {{
                                                    (globals.lang == 'ar')? field?.semesterNameAr :
                                                    field?.semesterNameEn
                                                    }}
                                                </option>
                                            </select>
                                            <div class="alert alert-danger py-1 mt-1"
                                                *ngIf="searchForm.controls.semester.touched && searchForm.controls.semester.invalid && searchForm.dirty">
                                                {{ "THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                            </div>
                                        </div>
                                        <div class="col-md-3 form-group px-md-5 mb-1">
                                            <label class="font-bold">{{ "BATCH" | translate | titlecase }}</label>
                                            <select class="form-control custom-select" formControlName="batch"
                                            (change)="getBatchGroups()">
                                                <option value="" [selected]="true">{{ "SELECT" | translate | titlecase
                                                    }}
                                                </option>
                                                <!-- <option value="202">{{ "static group" | translate | titlecase
                                                    }}
                                                </option> -->
                                                <option *ngFor="let field of batches" [ngValue]="field.id">
                                                    {{
                                                    (globals.lang == 'ar')? field?.gradeNameAr : field?.gradeNameEn
                                                    }}
                                                </option>
                                            </select>
                                            <div class="alert alert-danger py-1 mt-1"
                                                *ngIf="searchForm.controls.batch.touched && searchForm.controls.batch.invalid && searchForm.dirty">
                                                {{ "THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                            </div>
                                        </div>
                                         <div class="col-md-3 form-group px-md-5 mb-1">
                                            
                                            <label class="font-bold"> {{ "GROUP" | translate | titlecase }}</label>
                                            <select class="form-control custom-select" formControlName="group">
                                                <option value="" [selected]="true">{{ "SELECT" | translate |
                                                    titlecase
                                                    }}</option>
                                                
                                                <option *ngFor="let field of batchGroups" value="{{field.id}}">
                                                    {{(globals.lang == 'ar')? field.egroupNameAr :
                                                    field.egroupNameEn}} - ({{field.egroupCode}})</option>
                                            </select>
                                            <div class="alert alert-danger py-1 mt-1"
                                                *ngIf="searchForm.controls.group.touched && searchForm.controls.group.invalid && searchForm.dirty">
                                                {{ "THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                            </div> 
                                        </div> 
                                    </div>
                                     <div class="row">
                                        <div class="col-md-6 form-group px-md-5 mb-1"
                                            style="padding-top: 23px !important;">
                                            <button type="submit" class="btn btn-primary">
                                                {{ "SEARCH" | translate | titlecase }}</button>
                                        </div>
                                    </div> 
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                <br>
                <div class="table-responsive py-3" *ngIf="!showLoader" >
                    <div class="col-12 d-flex flex-wrap justify-content-between" *ngIf="searchFlag">
                        <!-- <div class="col-12 d-flex flex-wrap justify-content-between" *ngIf="globals.checkUserHasPermission('COUNTRIES - CREATE')"> -->
                        <button type="button" class="btn btn-success mb-2 mx-lg-0 mx-auto rounded-0"
                            routerLink="/attendence/available-dates/available-dates-create"
                            [queryParams]="{yearId: yearId,semesterId:semesterId,gradeId:batchId}"><i class="fas fa-plus"></i> {{ "ADD" | translate |
                            titlecase }}</button>
                    </div>
                    <div style="height: 500px; overflow-y: scroll;">
                        <table *ngIf="availableDates.length >= 1" class="table-striped" data-sticky-header="true" id="datatable">
                            <thead style="position: sticky; top: 0; background: white;">
                                <tr>
                                    <!-- <th>{{ "ID" | translate | titlecase }}</th> -->
                                    <th>{{ "DATE" | translate | titlecase }}</th>
                                    <th>{{ "STATUS" | translate | titlecase }}</th>
                                    <th>{{ "REMARKS" | translate | titlecase }}</th>
                                    <th>{{ "GROUP" | translate | titlecase }}</th>
                                    <th>{{ "COURSE" | translate | titlecase }}</th>
                                    <th class="border-0 font-14 px-2 text-grey">{{ "MODIFY" | translate | titlecase
                                        }}</th>
                                    <th class="border-0 font-14 px-2 text-grey">{{ "CANCEL" | translate | titlecase }}</th>
                                    <th class="border-0 font-14 px-2 text-grey">{{ "DELETE" | translate | titlecase }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let res of availableDates let i = index">
                                    <!-- <td>{{res?.id}}</td> -->
                                    <td>{{res?.daydate}}</td>
                                    <td>{{res?.statusFlag}}</td>
                                    <td>{{res?.remarks}}</td>
                                    <td>{{(res?.group)? (globals.lang == 'ar')? res?.group?.egroupNameAr + " - (" + (res?.group?.egroupCode)
                                        + ")" : res?.group?.egroupNameEn + " - (" + res?.group?.egroupCode + ")" : ''}}</td>
                                    <td>{{(globals.lang == 'ar')? res?.course?.subjectNameAr :
                                        res?.course?.subjectNameEn}}</td>
                                    <td class="text-bold text-warning">
                                        <a class="btn btn-sm btn-link text-warning" data-toggle="modal" data-target="#updateAvailableDate"
                                            (click)="getDateById(res?.id)"><i class="fas fa-edit"></i>
                                            {{ "MODIFY" | translate | titlecase }}</a>
                                    </td>
                                    <td class="text-bold text-warning">
                                        <a class="btn btn-sm btn-link text-warning" (click)="updateCurrentAvailableDate(res?.id)"
                                            data-toggle="modal" data-target="#cancelModal"><i class="fas fa-ban"></i>
                                            {{ "CANCEL" | translate | titlecase }}</a>
                                    </td>
                                    <td class="text-bold text-warning">
                                        <a class="btn btn-sm btn-link text-warning" (click)="updateCurrentAvailableDate(res?.id)"
                                            data-toggle="modal" data-target="#deleteModal"><i class="fas fa-trash"></i>
                                            {{ "DELETE" | translate | titlecase }}</a>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>


</div>

<!-- Modal DisableServiceData-->
<div class="modal fade" id="updateAvailableDate" tabindex="-1" aria-labelledby="updateAvailableDate" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <app-loader [show]="loadAvailableDateEdit"></app-loader>
            <form class="modal-content col-md-12" [formGroup]="updateAvailableDatePopup" (submit)="updateAvailableDate()" *ngIf="!loadAvailableDateEdit">
                <div class="modal-body px-md-12">
                    <div class="row">
                        <div class="col-md-4 form-group">
                            <label class="text-bold">{{ "START_DATE" | translate | titlecase }}</label>
                            <input type="datetime-local" class="form-control" formControlName="datetimeFrom">
                            <div class="alert alert-danger py-1 mt-1"
                                *ngIf="updateAvailableDatePopup.controls.datetimeFrom.touched && updateAvailableDatePopup.controls.datetimeFrom.invalid && updateAvailableDatePopup.dirty">
                                {{ "THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                            </div>
                        </div>
                        <div class="col-md-4 form-group">
                            <label class="text-bold">{{ "END_DATE" | translate | titlecase }}</label>
                            <input type="datetime-local" class="form-control" formControlName="datetimeTo">
                            <div class="alert alert-danger py-1 mt-1"
                                *ngIf="updateAvailableDatePopup.controls.datetimeTo.touched && updateAvailableDatePopup.controls.datetimeTo.invalid && updateAvailableDatePopup.dirty">
                                {{ "THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                            </div>
                        </div>
                        <!-- <div class="col-md-4 form-group">
                            <label class="text-bold">{{ "TIME" | translate | titlecase }}</label>
                            <input type="time" class="form-control" formControlName="time">
                            <div class="alert alert-danger py-1 mt-1"
                                *ngIf="updateAvailableDatePopup.controls.time.touched && updateAvailableDatePopup.controls.time.invalid && updateAvailableDatePopup.dirty">
                                {{ "THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                            </div>
                        </div> -->
                        <div class="col-md-4 form-group">
                            <label class="text-bold">{{ "STATUS" | translate | titlecase }}</label>
                            <input type="text" class="form-control" formControlName="status" readonly>
                        </div>
                        <div class="col-md-4 form-group">
                            <label class="text-bold">{{ "REMARKS" | translate | titlecase }}</label>
                            <textarea class="form-control" formControlName="remarks"></textarea>
                            <div class="alert alert-danger py-1 mt-1"
                                *ngIf="(updateAvailableDatePopup.controls.remarks.touched && updateAvailableDatePopup.controls.remarks.invalid && updateAvailableDatePopup.dirty)">
                                {{ "THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" id="close-available-date-popup" class="btn btn-outline-secondary"
                        data-dismiss="modal">{{ "CANCEL" | translate | titlecase }}</button>
                    <button type="submit" class="btn btn-primary">{{ "SAVE" | translate | titlecase }}</button>
                </div>
            </form>
        </div>
    </div>
</div>

<div class="modal fade" id="deleteModal" tabindex="-1" aria-labelledby="deleteModalLabel" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">

            <div class="modal-body font-16 text-center d-flex justify-content-between">
                <div class="p-2">
                    <i class="fas fa-trash text-danger"></i>
                </div>
                <div class="p-2"><b>{{ "ARE_YOU_SURE" | translate | titlecase }}</b> </div>

                <a type="button" class="btn btn-link text-danger" (click)="deleteAvailableDate()"
                    data-dismiss="modal">{{ "YES"
                    | translate | titlecase }}</a>
                <a type="button" class="btn btn-link text-grey" data-dismiss="modal"><i
                        class="fas fa-times-circle"></i></a>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="cancelModal" tabindex="-1" aria-labelledby="cancelModalLabel" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">

            <div class="modal-body font-16 text-center d-flex justify-content-between">
                <div class="p-2">
                    <i class="fas fa-trash text-danger"></i>
                </div>
                <div class="p-2"><b>{{ "ARE_YOU_SURE" | translate | titlecase }}</b> </div>

                <a type="button" class="btn btn-link text-danger" (click)="cancelAvailableDate()"
                    data-dismiss="modal">{{ "YES"
                    | translate | titlecase }}</a>
                <a type="button" class="btn btn-link text-grey" data-dismiss="modal"><i
                        class="fas fa-times-circle"></i></a>
            </div>
        </div>
    </div>
</div>